export const tableTitle = ['ID посилання', 'Номер пацієнта', "Ім'я лікаря", "Біопсія", 'Клінічне заключення', 'Клінічна інформація', 'Вид матеріалу', 'Дата операції', 'Назва операції', 'Кількість матеріала', 'Статус', 'Відділ дослідження', 'Скерування з іншої клініки', 'Назва клініки', 'Назва відділення','']

export const filterDate = [
    {name: 'id', placeholder: 'Пошук за ID'},
    {name: 'patientNumber', placeholder: 'Пошук за номером пацієнта'},
    {name: 'activeDoc', placeholder: "Пошук за ім'ям лікаря"},
    {name: 'biopsy', placeholder: 'Пошук за біопсією'},
    {name: 'clinicalConclusion', placeholder: 'Пошук за клінічним заключенням'},
    {name: 'clinicalInfo', placeholder: 'Пошук за клінічною інформацією'},
    {name: 'markedMaterial', placeholder: 'Пошук за видом матеріалу'},
    {name: 'operationDate', type: 'date', placeholder: 'Пошук за датою операції'},
    {name: 'operationName', placeholder: 'Пошук за назвою операції'},
    {name: 'quantityMaterial', placeholder: 'Пошук за кількістю матеріала'},
    {name: 'status', type: 'select', options: [{name:'Усі', value: ''}, {name:'Зареєстроване скерування', value: 'registered'},
    {name:'Сформована форма', value: 'scanAfterForm'},
    {name:'Готові до фарбування', value: 'scanBeforePaint'},
    {name:'Пофарбовані', value: 'scanAfterPaint'},
    {name:'Направлені до лікаря', value: 'toDoctor'}, {name:'Завершені', value: 'finished'}], placeholder: 'Пошук за статусом'},
    {name: 'research', type: 'select', options: [{name:'Усі', value: ''}, {name:'Гістологія', value: 'Гістологія'},
    {name:'ІГХ', value: 'ІГХ'},
    {name:'CISH', value: 'CISH'},
    {name:'Експрес', value: 'Експрес'},], placeholder: 'Пошук за відділом дослідження'},
    {name: 'outside', type: 'select', options: [{name:'Усі', value: ''}, {name:'Так', value: true}, {name:'Ні', value: false}], placeholder: 'Всі'},
    {name: 'hospital', placeholder: 'Пошук за клінікою'},
    {name: 'department', placeholder: 'Пошук за відділенням'},
]

export const searchOptions = [
    { "value": "id", "name": "за ID", "type": "number" },
    { "value": "patientNumber", "name": "за номером пацієнта", "type": "number" },
    { "value": "activeDoc", "name": "за ім'ям лікаря", "type": "text" },
    { "value": "biopsy", "name": "за біопсією", "type": "text" },
    { "value": "clinicalConclusion", "name": "за клінічним заключенням", "type": "text" },
    { "value": "clinicalInfo", "name": "за клінічною інформацією", "type": "text" },
    { "value": "markedMaterial", "name": "за видом матеріалу", "type": "text" },
    { "value": "operationDate", "name": "за датою операції", "type": "date" },
    { "value": "operationName", "name": "за назвою операції", "type": "text" },
    { "value": "quantityMaterial", "name": "за кількістю матеріала", "type": "text" },
    { "value": "status", "name": "за статусом", "type": "text" },
    { "value": "research", "name": "за відділом дослідження", "type": "text" },
    { "value": "hospitalId", "name": "за номером клініки", "type": "number" },
    { "value": "departmentId", "name": "за номером департамента", "type": "number" },
];

export const columnOrderReference = [
    "id",
    "patientNumber",
    "activeDoc",
    "biopsy",
    "clinicalConclusion",
    "clinicalInfo",
    "markedMaterial",
    "operationDate",
    "operationName",
    "quantityMaterial",
    "status",
    "research",
    "outside",
    "hospitalName",
    "departmentName",
]